import { requester } from '../utils';

export const applyDiscountCode = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/discount-code/apply`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('apply discount code error', err);
        reject(err);
      });
  });
};
